export default __webpack_public_path__ + "static/media/loginGraphic.2de85e00.svg";